// removed by extract-text-webpack-plugin
module.exports = {"container":"AccessDenied__container___3LCD2"};